import { DatePipe } from '@angular/common';
import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { ToastrService } from 'ngx-toastr';
import { SchedulerMessageValidationConst } from '../../../../core/const';

@Component({
	selector: 'lib-new-campaign-scheduler',
	templateUrl: './scheduler.component.html',
	styleUrls: ['./scheduler.component.scss'],
})
export class SchedulerComponent implements OnInit {
	@Output()
	public scheduler: EventEmitter<FormGroup>;

	public form: FormGroup;
	public minDate: Date;
	public validationMessages: any;

	private datePipe: DatePipe;

	@Input() public isReadOnlyMode: boolean;

	constructor(private toastr: ToastrService) {
		this.datePipe = new DatePipe('en-US');
		this.scheduler = new EventEmitter();
	}

	ngOnInit(): void {
		this.validationMessages = SchedulerMessageValidationConst;
		this.minDate = new Date();

		this.initForm();
		this.initEdit();
		this.initDisable();
	}

	private initForm(): void {
		this.form = new FormGroup({
			schedulerType: new FormControl(null, Validators.required),
			startDate: new FormControl(null),
			startTime: new FormControl(null),
			isRepeat: new FormControl(false),
			delivery: new FormControl(null),
		});

		this.form.valueChanges.subscribe(() => {
			this.scheduler.emit(this.form);
		});
	}

	private initDisable(): void {
		if (!this.isReadOnlyMode) {
			return;
		}

		this.form.disable();
	}

	private initEdit(isEdit: boolean = true): void {
		const campaign = localStorage.getItem('telin.campaign')
			? JSON.parse(localStorage.getItem('telin.campaign'))
			: {};

		if (Object.entries(campaign).length === 0) return;

		if (isEdit)
			this.form
				.get('schedulerType')
				.setValue(campaign?.scheduler?.schedulerType);

		this.form.get('startDate').setValue(campaign?.scheduler?.startDate);
		this.form.get('startTime').setValue(campaign?.scheduler?.startTime);
		this.form.get('isRepeat').setValue(campaign?.scheduler?.isRepeat);
		this.form
			.get('delivery')
			.setValue(
				this.capitalizeFirstLetter(campaign?.scheduler?.delivery)
			);
	}

	private capitalizeFirstLetter(value: string): string {
		if (!value) return '';

		return (
			value?.charAt(0).toUpperCase() + value?.slice(1).toLowerCase() ?? ''
		);
	}

	public updateSchedulerType(type: string): void {
		this.form.get('schedulerType').setValue(type);

		if (this.form.get('schedulerType').value === 'NOW') {
			this.form.get('startDate').setValue(null);
			this.form.get('startDate').clearValidators();
			this.form.get('startDate').updateValueAndValidity();
			this.form.get('startTime').setValue(null);
			this.form.get('startTime').clearValidators();
			this.form.get('startTime').updateValueAndValidity();
			this.form.get('delivery').setValue(null);
			this.form.get('delivery').clearValidators();
			this.form.get('delivery').updateValueAndValidity();
			this.form.get('isRepeat').setValue(false);
			return;
		}

		this.form.get('startDate').setValidators(Validators.required);
		this.form.get('startDate').updateValueAndValidity();
		this.form.get('startTime').setValidators(Validators.required);
		this.form.get('startTime').updateValueAndValidity();
		this.initEdit(false);
	}

	public updateTime(): void {
		if (!this.form.get('startDate').value) return;

		const dateNow = new Date().getTime();
		const startDate = new Date(
			`${this.datePipe.transform(
				this.form.get('startDate').value,
				'yyyy-MM-dd'
			)} ${this.form.get('startTime').value}`
		).getTime();

		if (dateNow > startDate) {
			this.form.get('startTime').setValue(null);
			this.toastr.error('Selected time has been surpassed');
		}
	}

	public updateRepeat(isChecked: boolean): void {
		if (isChecked) {
			this.form.get('delivery').setValidators(Validators.required);
			this.form.get('delivery').updateValueAndValidity();
			return;
		}

		this.form.get('isRepeat').setValue(null);
		this.form.get('delivery').setValue(null);
		this.form.get('delivery').clearValidators();
		this.form.get('delivery').updateValueAndValidity();
	}
}
